<template>
  <div>
    <v-radio-group
      :disabled="$store.getters.isDisabled"
      :value="value"
      @change="$emit('input', $event)"
      hide-details="auto"
    >
      <v-radio
        v-for="item in items"
        :key="'option-' + item.slug"
        :label="item.title"
        :value="item.slug"
      >
        <template v-slot:label>
          <div>{{ item.title }}</div>
          <div>
            <v-chip
              class="ml-2"
              style
              v-bind="{ color: 'blue-grey darken-2', ...item.chipProps }"
              dark
              v-if="item.chip"
            >
              {{ item.chip }}
            </v-chip>
          </div>
        </template>
      </v-radio>
    </v-radio-group>
    <div class="ma-3" v-if="selectedItem">
      <v-img max-width="150" :src="selectedItem.image"></v-img>
      <small class="text--secondary">{{ selectedItem.subtitle }}</small>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },

    /**
     * If null or "index", then index of option is used.
     */
    valueField: {
      type: String,
      default: "slug",
    },

    items: {
      type: Array,
      default: () => [
        {
          slug: "some-slug",
          image: "/path/to/image.jpg",
          title: "Item Title",
          subtitle: "Description",
          color: "#FFE5AA",
        },
      ],
    },
  },

  computed: {
    selectedItem() {
      return this.items.find((item) => item.slug === this.value);
    },
  },
};
</script>

